import AdministrationUserInterface from 'src/types/AdministrationUserInterface'
import { UserInterface } from 'src/types/UserInterface'
import { AccountInformations } from './account'
import { ADMIN } from './constants/role'

/**
 * Get user full name
 */
export const getUserFullNameFn = (user: UserInterface) => {
  if (!user) {
    return '-'
  }
  const { first_name: firstName, last_name: lastName, email } = user
  if (!firstName && !lastName) {
    return email ?? '-'
  }
  return `${firstName || ''}${firstName && lastName ? ' ' : ''}${lastName || ''}`
}

/**
 * Get full user account name
 */
export const getUserAccountNameFn = (
  userAccount: Pick<AccountInformations, 'first_name' | 'last_name'>,
): string => getUserFullNameFn(userAccount as UserInterface)

/**
 * Check if user is admin
 */
export const isUserAdminFn = (user: Pick<AccountInformations, 'default_company_right'>) =>
  user?.default_company_right === ADMIN

/**
 * Get administration user name
 */
export const getAdministrationUserNameFn = (
  user: AdministrationUserInterface['user'],
  deletion = false,
) => {
  if (!user) {
    return '-'
  }
  const { first_name: firstName, last_name: lastName, email } = user
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }
  if (firstName) {
    return firstName
  }
  if (lastName) {
    return lastName
  }
  return deletion ? email : '-'
}
